import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

const cryptoApiHeaders ={
    'X-RapidAPI-Key': '60be93d2d9msh73fc66389d105fap11e690jsna0bfbebb8667',
    'X-RapidAPI-Host': 'coinranking1.p.rapidapi.com'
}

const baseUrl = 'https://coinranking1.p.rapidapi.com'

const createRequest = url =>({url, headers:cryptoApiHeaders})

export const cryptoApi = createApi({
    reducerPath:'cryptoApi',
    baseQuery:fetchBaseQuery({baseUrl}),
    endpoints:(builder) =>({
        getCryptos:builder.query({
            query:(count) => createRequest(`/coins?limit=${count}`)
    }),
    getExchanges:builder.query({
        query:(c) => createRequest(`/exchanges`)
}),
    getCryptoDetails:builder.query({
        query:(coinId) => createRequest(`/coin/${coinId}`)
    }),
    getCryptoHistory:builder.query({
        query:({coinId, timePeriod }) => createRequest(`/coin/${coinId}/history?${timePeriod}`)
    }),
    })
})
export const {useGetCryptosQuery,useGetExchangesQuery,useGetCryptoDetailsQuery,useGetCryptoHistoryQuery} = cryptoApi

